import { useCallback, useContext } from 'react';
import { AppContext, AppState } from '../../context/AppContext/context';

function useSelectedSplitPaymentsGroup() {
  const { state: appState, dispatch: appDispatch } = useContext(AppContext);

  const setSelectedSplitPaymentsGroupId = useCallback(
    (payload: AppState['selectedSplitPaymentsGroupId']) => {
      appDispatch({ type: 'SET_SELECTED_SPLIT_PAYMENTS_GROUP_ID', payload });
    },
    [appDispatch],
  );

  return {
    selectedSplitPaymentsGroupId: appState.selectedSplitPaymentsGroupId,
    setSelectedSplitPaymentsGroupId,
  };
}

export default useSelectedSplitPaymentsGroup;
